import React, { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";

function UnsubscribeModal({
  toggle,
  setToggle,
  onUnsubscribe,
  infos,
  error,
  intl,
}) {
  const [immediate, setImmediate] = useState(
    !!(
      (infos.subscription && infos.subscription.subscriptionId === "NA") ||
      (infos.pending && infos.pending.plan && infos.pending.plan.planId == "0")
    )
  );
  const [checkboxes, setCheckBoxes] = useState({
    credits_checkbox: false,
    features_checkbox: false,
    date_checkbox: false,
    warning_checkbox: false,
    reason_of_leaving: false,
    reason_text: "",
  });
  const [hideImmediate, setHideImmediate] = useState(false);

  useEffect(() => {
    if (infos.subscription && infos.subscription.nonRenewalNoticeDeadline) {
      if (
        new Date(infos.subscription.nonRenewalNoticeDeadline).getTime() <
        Date.now()
      ) {
        setImmediate(false);
        setHideImmediate(true);
      }
    }
  }, []);
  const handleOnChange = (e) => {
    const currentCheckboxes = Object.assign({}, checkboxes);
    currentCheckboxes[e.target.id] =
      e.target.id === "reason_of_leaving" || e.target.id === "reason_text"
        ? e.target.value
        : e.target.checked;

    if (e.target.id == "reason_text") {
      currentCheckboxes["reason_of_leaving"] = "Other - " + e.target.value;
    }
    setCheckBoxes(currentCheckboxes);
  };
  const boxesAreChecked = () => {
    const boxesKeys = Object.keys(checkboxes);
    const verifyCheckBoxes = boxesKeys.filter(
      (checkBoxId) => checkboxes[checkBoxId]
    );
    let checkboxesLength =
      checkboxes.reason_of_leaving &&
      checkboxes.reason_of_leaving.match("Other")
        ? verifyCheckBoxes.length
        : verifyCheckBoxes.length + 1;
    return checkboxesLength === boxesKeys.length;
  };
  const unsubscription_date = () => {
    return (
      " " +
      (infos.subscription &&
        new Intl.DateTimeFormat("fr-FR").format(
          new Date(infos.subscription.endDate)
        ))
    );
  };
  return (
    <Modal
      show={toggle ? true : false}
      onHide={setToggle}
      className="fade  unsubscribe-modal-wrapper"
      id="unsubscribe-modal"
    >
      <Modal.Header closeButton className="border-0">
        <div className="modal-inner-header">
          <h4 className="title">
            <FormattedMessage
              id={"billing.areYouSureYouWantToCancelYourSubscription"}
            />
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body p-0">
        <div className="unsubscribe-ui-block p-24">
          {infos.subscription && infos.subscription.subscriptionId !== "NA" && (
            <div>
              <div>
                <label
                  onClick={() => setImmediate(false)}
                  style={
                    infos.pending &&
                    infos.pending.plan &&
                    infos.pending.plan.planId == "0"
                      ? { color: "#a6a6a6", pointerEvents: "none" }
                      : {}
                  }
                >
                  <input
                    type="radio"
                    readOnly={true}
                    checked={
                      immediate === false &&
                      infos.subscription &&
                      infos.subscription.subscriptionId !== "NA"
                    }
                  />{" "}
                  <span>
                    <FormattedMessage id={"billing.unsubscribeOn"} />
                    <span className="link-text">
                      {unsubscription_date()}
                    </span>{" "}
                    <strong>
                      {" "}
                      <FormattedMessage id={"billing.endOfSubscription"} />
                    </strong>
                  </span>
                </label>
              </div>
              {!hideImmediate && (
                <div>
                  <label onClick={() => setImmediate(true)}>
                    <input
                      type="radio"
                      readOnly={true}
                      defaultChecked={
                        infos.subscription &&
                        infos.subscription.subscriptionId === "NA"
                      }
                      checked={
                        immediate === true ||
                        (infos.subscription &&
                          infos.subscription.subscriptionId === "NA")
                      }
                    />{" "}
                    <span>
                      {" "}
                      <FormattedMessage id={"billing.unsubscribeImmediately"} />
                    </span>
                  </label>
                </div>
              )}
            </div>
          )}
          <div className="alert-wrap unsubscribe_popup">
            <ul>
              <li>
                <label htmlFor="credits_checkbox">
                  <input
                    type="checkbox"
                    id={"credits_checkbox"}
                    readOnly
                    onChange={handleOnChange}
                  />{" "}
                  <FormattedMessage
                    id={"billing.allYourRemainingWillBeDeleted"}
                    values={{
                      strong: (chunk) => <strong> {chunk} </strong>,
                    }}
                  />
                  <strong>
                    {immediate
                      ? intl.formatMessage({ id: "billing.immediately" })
                      : intl.formatMessage({ id: "billing.on" }) +
                        unsubscription_date()}{" "}
                  </strong>
                  <span className={"star"}>*</span>
                </label>
              </li>
              <li>
                <label htmlFor="features_checkbox">
                  <input
                    type="checkbox"
                    id={"features_checkbox"}
                    onChange={handleOnChange}
                    readOnly
                  />{" "}
                  <FormattedMessage
                    id={"billing.youWillNoLongerHaceAccessToYour_"}
                  />
                  <strong>
                    {" "}
                    <FormattedMessage id={"billing.kasprFeatures"} />
                  </strong>
                  <strong>
                    {immediate
                      ? intl.formatMessage({ id: "billing.immediately" })
                      : intl.formatMessage({ id: "billing.on" }) +
                        unsubscription_date()}
                  </strong>{" "}
                  <span className={"star"}>*</span>
                </label>
              </li>
              <li>
                <label htmlFor="administration_checkbox">
                  <input
                    type="checkbox"
                    id={"administration_checkbox"}
                    onChange={handleOnChange}
                    readOnly
                  />{" "}
                  {immediate ? (
                    <FormattedMessage id={"billing.onlyYouAdmin"} />
                  ) : (
                    <FormattedMessage id={"billing.onlyOwnerAdmin"} />
                  )}
                  <strong>
                    {immediate
                      ? intl.formatMessage({ id: "billing.immediately" })
                      : intl.formatMessage({ id: "billing.on" }) +
                        unsubscription_date()}
                  </strong>{" "}
                  <span className={"star"}>*</span>
                </label>
              </li>
              <li>
                <label htmlFor="date_checkbox">
                  <input
                    type="checkbox"
                    id={"date_checkbox"}
                    onChange={handleOnChange}
                    readOnly
                  />{" "}
                  <FormattedMessage id={"billing.myUnsubscription"} />
                  <strong>
                    {immediate
                      ? intl.formatMessage({ id: "billing.now" })
                      : intl.formatMessage({ id: "billing.on" }) +
                        unsubscription_date()}{" "}
                  </strong>
                  <span className={"star"}>*</span>
                </label>
              </li>
              <li>
                <label htmlFor="warning_checkbox">
                  <input
                    type="checkbox"
                    id={"warning_checkbox"}
                    onChange={handleOnChange}
                    readOnly
                  />{" "}
                  <FormattedMessage id={"billing.iRecognizeThatThisActionIs"} />
                  <strong>
                    <FormattedMessage id={"billing.immediateAndDefinitive"} />{" "}
                  </strong>
                  <span className={"star"}>*</span>
                </label>
              </li>
            </ul>
          </div>
          <div className={"why-container"}>
            <h6>
              <FormattedMessage id={"billing.whyYouLeaveUs"} />{" "}
              <span className={"star"}>*</span>
            </h6>
            <p style={{ color: "#555", fontSize: 15 }}>
              <FormattedMessage id={"billing.havingFeedBackFromYou"} />
            </p>
            <select
              name=""
              id="reason_of_leaving"
              onChange={handleOnChange}
              style={checkboxes.reason_of_leaving ? {} : { borderColor: "red" }}
            >
              <option value="">
                {" "}
                {intl.formatMessage({ id: "billing.selectAReason" })}
              </option>
              <option value="I don't need Kaspr for now but i'll come back later">
                {intl.formatMessage({ id: "billing.iDontNeedKasprForNow" })}
              </option>
              <option value="I chose an other competitor">
                {intl.formatMessage({ id: "billing.iChooseAnOtherCompetitor" })}
              </option>
              <option value="Too expensive">
                {intl.formatMessage({ id: "billing.tooExpensive" })}
              </option>
              <option value="Not enough data">
                {intl.formatMessage({ id: "billing.notEnoughData" })}
              </option>
              <option value="I leave the company">
                {intl.formatMessage({ id: "billing.iLeaveTheCompany" })}
              </option>
              <option value="I just change my subscription">
                {intl.formatMessage({
                  id: "billing.iJustChangeMySubscription",
                })}
              </option>
              <option value="Other">
                {intl.formatMessage({ id: "billing.other" })}
              </option>
            </select>
          </div>
          {checkboxes.reason_of_leaving &&
            checkboxes.reason_of_leaving.match("Other") && (
              <div className={"why-textarea-container"}>
                <label htmlFor="reason_text">
                  <FormattedMessage id={"billing.reasonOfLeaving"} />
                </label>
                <textarea
                  name="reason_text"
                  id="reason_text"
                  cols="60"
                  rows="4"
                  placeholder={intl.formatMessage({ id: "billing.reason" })}
                  onChange={handleOnChange}
                />
              </div>
            )}
          {error && (
            <p style={{ color: "red", textAlign: "center" }}>{error}</p>
          )}
          <div className="button-block-wrap" style={{ marginTop: 20 }}>
            <div className="left-ui">
              {/*  <a
                href="#"
                onClick={() => (window.location = "/billing")}
                className="btn2 btn-md"
              >
                Update plan
              </a>*/}
            </div>

            <div className="right-ui">
              <a href="#" className="btn3 btn-md" onClick={setToggle}>
                <FormattedMessage id={"billing.cancel"} />
              </a>
              <a
                href="#"
                className={
                  "btn1 btn-md " + (boxesAreChecked() ? "" : "btn-disabled")
                }
                onClick={() =>
                  boxesAreChecked() &&
                  onUnsubscribe(immediate, checkboxes.reason_of_leaving)
                }
              >
                <FormattedMessage id={"billing.unsubscribe"} />
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className=" border-0">
        <div className="contact-support">
          <div className="left-ui">
            <h6>
              <FormattedMessage id={"billing.havingAnyIssuesOrQuestions"} />
            </h6>
            <p>
              <FormattedMessage
                id={
                  "billing.ourSuperFriendlyCustomerSupportCanHelpYouWithAnyQuestionOrIssue"
                }
              />
            </p>
          </div>
          <div className="right-ui">
            <a
              target="_blank"
              href="https://kaspr.io/contact/"
              className="contact-support-btn"
            >
              <span className="ic-call-ui">
                <img src="/assets/images/ic-call.svg" alt="" />
              </span>
              <FormattedMessage id={"billing.contactUs"} />
            </a>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default injectIntl(UnsubscribeModal);
